import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question-list-con" }
const _hoisted_2 = { class: "total-num" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "question-bottom" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_no_data = _resolveComponent("no-data")!
  const _component_rocket = _resolveComponent("rocket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.questionData.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, "共收藏" + _toDisplayString(_ctx.totalNum) + "道题目", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionData, (question, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "question-item",
              key: index
            }, [
              _createVNode(_component_question_detail, {
                showKnowledgePoint: true,
                questionIndex: index+1,
                isList: true,
                onClick: ($event: any) => (_ctx.linkDetails(question)),
                questionData: question
              }, null, 8, ["questionIndex", "onClick", "questionData"]),
              _hoisted_3
            ]))
          }), 128)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_van_loading, { size: "24px" }, {
                  default: _withCtx(() => [
                    _createTextVNode("加载中...")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.hasAjaxData && _ctx.questionData.length === 0)
      ? (_openBlock(), _createBlock(_component_no_data, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isShowRocket)
      ? (_openBlock(), _createBlock(_component_rocket, {
          key: 2,
          onClick: _ctx.goTop
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}